import styles from './SuggestionChips.module.css';

const SUGGESTIONS = [
  'Hvor kan vi spare penge?',
  'Bruger vi for meget på dagligvarer?',
  'Hvad sker der med bil-budgettet?',
  'Hvornår når vi vores feriemål?',
];

interface Props {
  onPick(text: string): void;
}

export function SuggestionChips({ onPick }: Props) {
  return (
    <div className={styles.chips}>
      {SUGGESTIONS.map((s) => (
        <button key={s} className={styles.chip} onClick={() => onPick(s)}>
          {s}
        </button>
      ))}
    </div>
  );
}
